import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, doc, setDoc, updateDoc } from "firebase/firestore";
import escribirLog from "./escribirLog";

async function añadirOtros(infoProducto, autor, baseDatos) {
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, baseDatos);
  const docRef = doc(collectionRef);
  await setDoc(docRef, infoProducto);

  await updateDoc(docRef, {
    id: docRef.id
  });

  escribirLog("Creación", infoProducto, autor);
}

export default añadirOtros;
